import { api } from '../../Lib/constants'
import { getAuthHeader } from '../../Lib/utils'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SHAREHOLDERS, SHAREHOLDERS_SUCCESS, SHAREHOLDERS_FAILED, SHAREHOLDERSLIST, SHAREHOLDERSLIST_SUCCESS, SHAREHOLDERSLIST_FAILED, ROLESLIST, ROLESLIST_SUCCESS, ROLESLIST_FAILURE, UPDATE, UPDATE_SH_SUCCESS, UPDATE_SH_FAILURE, ADDSHAREHOLDERS, ADDSHAREHOLDERS_SUCCESS, ADDSHAREHOLDERS_FAILED, UPDATESHAREHOLDERS, UPDATE_SHAREHOLDERS_SUCCESS, UPDATE_SHAREHOLDERS_FAILURE, SHAREHOLDERSGROUPSLIST, SHAREHOLDERSGROUPSLIST_FAILED, SHAREHOLDERSGROUPSLIST_SUCCESS, UPDATESHAREHOLDERSGROUP, ADDSHAREHOLDERSGROUP, ADDSHAREHOLDERSGROUP_SUCCESS, ADDSHAREHOLDERSGROUP_FAILED, UPDATE_SHAREHOLDERSGROUP_SUCCESS, UPDATE_SHAREHOLDERSGROUP_FAILURE } from './actionTypes'
import { LOGIN_SUCCESS } from '../Authentication/actionTypes';

export const getShareholders = () => async dispatch => {
    dispatch({
        type: SHAREHOLDERS
    })
    try {
        let response = await api(`shareholders/all`, 'get', {}, getAuthHeader())
        console.log('shareholders data', response);
        dispatch({
            type: SHAREHOLDERS_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("fetching shareholders error ====>>>", error);
        return Promise.reject(dispatch({
            type: SHAREHOLDERS_FAILED,
            payload: error?.message
        }))
    }
}

export const getShareholdersList = () => async dispatch => {
    dispatch({
        type: SHAREHOLDERSLIST
    })
    try {
        let response = await api(`shareholders/list`, 'get', {}, getAuthHeader())
        console.log("shareholderslist data", response);
        dispatch({
            type: SHAREHOLDERSLIST_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while fetching shareholderslist error ====>", error);
        return Promise.reject(dispatch({
            type: SHAREHOLDERSLIST_FAILED,
            payload: error?.message
        }))
    }
}

export const getAllRoles = () => async dispatch => {
    dispatch({
        type: ROLESLIST
    })
    try {
        let response = await api(`shareholders/roles`, 'get', {}, getAuthHeader())
        console.log("All Roles", response);
        dispatch({
            type: ROLESLIST_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("While Fetching All Roles from Database Error=====>", error);
        return Promise.reject(dispatch({
            type: ROLESLIST_FAILURE,
            payload: error?.message
        }))
    }
}

export const addShareholder = (shareholder) => async dispatch => {
    dispatch({
        type: ADDSHAREHOLDERS
    })
    try {
        const response = await api('shareholders/add', "post", shareholder, getAuthHeader())
        response && toast.success("Added Successfully");
        dispatch({
            type: ADDSHAREHOLDERS_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("adding shareHolder error is ===> ", error);
        toast.error(error);
        return Promise.reject(dispatch({
            type: ADDSHAREHOLDERS_FAILED,
            payload: error?.message
        }))
    }
}

export const updateShareholder = (id, data) => async dispatch => {
    dispatch({
        type: UPDATESHAREHOLDERS
    })
    try {
        const { role_name, ...putdata } = data;
        let response = await api(`shareholders/update/${id}`, 'put', putdata, getAuthHeader());
        if (response) {
            const loggedInUser = JSON.parse(localStorage.getItem('user'));
            const loggedInUserId = loggedInUser.id;

            // If we update the logged in user then we have to update the localstorage data also
            if (loggedInUserId === id) {
                const updateLoggedInUserData = {
                    ...loggedInUser,
                    email: data.updatedEmail ? data.updatedEmail : data.email,
                    mobile: data.updatedMobile ? data.updatedMobile : data.mobile,
                    name: data.name,
                    role: {
                        ...loggedInUser.role,
                        name: role_name
                    }
                }
                localStorage.setItem('user', JSON.stringify(updateLoggedInUserData));
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: updateLoggedInUserData
                })
            }
            toast.success("Updated Successfully");
        }

        dispatch({
            type: UPDATE_SHAREHOLDERS_SUCCESS,
            payload: response?.data
        })
        return response;
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data || error?.message);
        return Promise.reject(dispatch({
            type: UPDATE_SHAREHOLDERS_FAILURE,
            payload: error?.data || error?.message
        }))
    }
}

export const getShareholdersGroupsList = () => async dispatch => {
    dispatch({
        type: SHAREHOLDERSGROUPSLIST
    })
    try {
        let response = await api(`shareholders/shareholdersgroups_list`, 'get', {}, getAuthHeader())
        console.log("shareholdersgroups_list data", response);
        dispatch({
            type: SHAREHOLDERSGROUPSLIST_SUCCESS,
            payload: response?.data,
        })
        return response
    } catch (error) {
        console.log("while fetching shareholdersgroups_list error ====>", error);
        return Promise.reject(dispatch({
            type: SHAREHOLDERSGROUPSLIST_FAILED,
            payload: error?.message
        }))
    }
}

export const addShareholderGroup = (shareHolderGroup) => async dispatch => {
    dispatch({
        type: ADDSHAREHOLDERSGROUP
    })
    try {
        console.log(shareHolderGroup, "shareHolderGroup");
        const response = await api('shareholders/add_shareholders_group', "post", shareHolderGroup, getAuthHeader())
        response && toast.success("Added Successfully");
        dispatch({
            type: ADDSHAREHOLDERSGROUP_SUCCESS,
            payload: response
        })
    } catch (error) {
        console.log("adding shareHolder error is ===> ", error);
        toast.error(error);
        return Promise.reject(dispatch({
            type: ADDSHAREHOLDERSGROUP_FAILED,
            payload: error?.message
        }))
    }
}

export const updateShareholderGroup = (id, data) => async dispatch => {
    dispatch({
        type: UPDATESHAREHOLDERSGROUP
    })
    try {
        const { ...putdata } = data;
        console.log(data, id, "data");
        let response = await api(`shareholders/update_shareholders_group/${id}`, 'put', putdata, getAuthHeader());
        dispatch({
            type: UPDATE_SHAREHOLDERSGROUP_SUCCESS,
            payload: response?.data
        })
        return response;
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data || error?.message);
        return Promise.reject(dispatch({
            type: UPDATE_SHAREHOLDERSGROUP_FAILURE,
            payload: error?.data || error?.message
        }))
    }
}